<template>
  <BaseModal class="modal_video" v-on="$listeners">
    <BaseVideo v-bind="video" is-round />
<!--     <button type="button" class="modal__close" @click="$emit('click:close')">
      <span class="visually-hidden">Закрыть окно</span>
      <BaseIcon name="cross" class="modal__cross" />
    </button> -->
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue';
import BaseVideo from '@/components/BaseVideo.vue';
// import BaseIcon from '@/components/BaseIcon.vue';

export default {
  name: 'TheVideoModal',
  components: {
    BaseModal,
    BaseVideo,
    // BaseIcon,
  },
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="stylus">
.modal

  &_video
    // background-color alpha($c_bright, 90%)
    // background-color rgba(10, 128, 196, 0.75)

    & ^[0]__content
      // position relative
      width 100%
      max-width 100%
      padding 0
      background #000
      box-shadow none
      align-self center
      +landscape()
        max-width 80%
</style>
